<template>
    <canvas ref="chartCanvas" :width="canvasWidth" :height="canvasHeight"></canvas>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            required: true
        },
        canvasWidth: {
            type: Number,
            default: 900
        },
        canvasHeight: {
            type: Number,
            default: 80
        }
    },
    mounted() {
        if (this.data && Array.isArray(this.data)) {
            if (this.data.length > 0) {
                this.drawChart();
            }
        }


    },
    methods: {
        drawChart() {
            const canvas = this.$refs.chartCanvas;
            const ctx = canvas.getContext('2d');
            let data = this.data;

            // 绘制折线
            ctx.beginPath();
            ctx.moveTo(50, this.canvasHeight - (data[0] / 4)); // 适应画布高度
            for (let i = 1; i < data.length; i++) {
                ctx.lineTo(50 + i * 83, this.canvasHeight - (data[i] / 4)); // 适应画布高度
            }
            ctx.strokeStyle = '#C5C5C5';
            ctx.stroke();

            // 在每个点上方显示数值
            ctx.fillStyle = '#333333';
            ctx.font = '12px Arial';
            for (let i = 0; i < data.length; i++) {
                ctx.fillText(data[i], 45 + i * 83, this.canvasHeight - 10 - (data[i] / 4)); // 适应画布高度
            }

            // 标注点
            ctx.fillStyle = '#C5C5C5';
            for (let i = 0; i < data.length; i++) {
                ctx.beginPath();
                ctx.arc(50 + i * 83, this.canvasHeight - (data[i] / 4), 3, 0, Math.PI * 5); // 适应画布高度
                ctx.fill();
            }

            // 最后一个点
            ctx.beginPath();
            ctx.arc(50 + (data.length - 1) * 83, this.canvasHeight - (data[data.length - 1] / 4), 3, 0, Math.PI * 5);
            ctx.fill();

        }
    }
};
</script>

<style scoped>
/* 可以在这里添加样式 */
</style>
